import { RootState } from '@/store/types'
import { Module } from 'vuex'
import { PronosticoAireState } from '@/store/modules/pronostico-aire/types'
import { getters } from '@/store/modules/pronostico-aire/getters'
import { actions } from '@/store/modules/pronostico-aire/actions'
import { mutations } from '@/store/modules/pronostico-aire/mutations'

export const state: PronosticoAireState = {
  pronostico: [],
  etiqueta_list: [],
  link_descarga: false,
  estacion_id: '',
  isLoaded: false,
  error: { state: false }
}

const namespaced: boolean = true

export const pronosticoAire: Module<PronosticoAireState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
